"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleChannelAppProductPagesOptionsQuerySchema = exports.AppleChannelProductPagesOptionsResponseSchema = exports.AppleChannelProductPageOptionsResponseSchema = exports.AppleApplicationsResponseSchema = exports.AppleApplicationSchema = exports.AppleApplicationQuerySchema = exports.ProductPageBrowseChannelOptionsResponseSchema = exports.AppleTodayTabsChannelOptionsResponseSchema = exports.AppleSearchTabsChannelOptionsResponseSchema = exports.AppleSearchResultsChannelOptionsResponseSchema = exports.AppleChannelOptionsResponseSchema = exports.AppleChannelOptionSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const apple_auth_web_1 = require("../../apple-auth-web");
const apple_proxy_web_1 = require("../../apple-proxy-web");
exports.AppleChannelOptionSchema = (0, core_1.StrictObject)({
    budgetOrders: typebox_1.Type.Array(apple_proxy_web_1.AppleProxyBudgetOrderSchema),
    organisation: apple_auth_web_1.AppleOrganisationInfoSchema,
    appleCampaigns: (0, core_1.StrictObject)({
        total: core_1.CountSchema,
    }),
});
exports.AppleChannelOptionsResponseSchema = (0, core_1.StrictObject)({
    options: typebox_1.Type.Array(exports.AppleChannelOptionSchema),
});
exports.AppleSearchResultsChannelOptionsResponseSchema = exports.AppleChannelOptionsResponseSchema;
exports.AppleSearchTabsChannelOptionsResponseSchema = exports.AppleChannelOptionsResponseSchema;
exports.AppleTodayTabsChannelOptionsResponseSchema = exports.AppleChannelOptionsResponseSchema;
exports.ProductPageBrowseChannelOptionsResponseSchema = exports.AppleChannelOptionsResponseSchema;
exports.AppleApplicationQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    query: typebox_1.Type.Optional(core_1.SearchStringSchema),
});
exports.AppleApplicationSchema = (0, core_1.StrictObject)({
    appRef: ruby_1.AppleProxyRefSchema,
    appName: core_1.NameSchema,
    developerName: core_1.NameSchema,
    countries: typebox_1.Type.Array(core_1.CountrySchema),
});
exports.AppleApplicationsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleApplicationSchema);
exports.AppleChannelProductPageOptionsResponseSchema = (0, core_1.StrictObject)({
    productPage: apple_proxy_web_1.AppleProxyProductPageDetailSchema,
    locales: typebox_1.Type.Array(apple_proxy_web_1.AppleProxyProductPageLocaleDetailSchema),
});
exports.AppleChannelProductPagesOptionsResponseSchema = (0, core_1.StrictObject)({
    productPages: typebox_1.Type.Array(exports.AppleChannelProductPageOptionsResponseSchema),
});
exports.AppleChannelAppProductPagesOptionsQuerySchema = (0, core_1.StrictObject)({
    teamId: core_1.IdSchema,
    applicationRef: ruby_1.AppleProxyRefSchema,
});
